import Invoices from './Invoices';

/**
 * NewInvoices — thin wrapper that renders the Invoices page in "new"
 * mode. Lives at /invoices/new and surfaces every supplier with
 * unbilled approved timesheets ready to invoice. The actual table is
 * implemented inside Invoices.jsx; this file exists so App.jsx routes
 * have a clean per-tab component to point at.
 */
export default function NewInvoices() {
  return <Invoices view="new" />;
}
